import React, { Component } from "react";
import { connect } from "react-redux";
import Page from "../../common/Page";
import { loadFaQs, updateFaqUsefulnessScore } from "../../../redux/actions/FaQActions";
import QuestionList from "./QuestionList";
import { Form } from "react-bootstrap";
import FormRow from "../../common/forms/FormRow";
import FAQEditorModal from "./FAQEditorModal";

class FaQPage extends Component {
  render() {
    return (
      <Page
        ignoreStyleForBody
        pageTitle="Frequently Asked Questions"
        pageHeader={
          this.props.isAdmin ? (
            <Form>
              <FormRow rightJustified columns={[<FAQEditorModal />]} />
            </Form>
          ) : null
        }
      >
        <QuestionList
          isAdmin={this.props.isAdmin || false}
          questions={this.props.questions}
          updateUsefulnessScore={this.updateUsefulnessScore}
        />
      </Page>
    );
  }

  constructor(props) {
    super(props);

    this.updateUsefulnessScore = this.updateUsefulnessScore.bind(this);
  }

  componentDidMount() {
    this.props.loadFaQs();
  }

  updateUsefulnessScore(questionId, scoreChange) {
    this.props.updateFaqUsefulnessScore(questionId, scoreChange);
  }
}

function mapStateToProps(state) {
  return {
    questions: state.FaQs.sort((a, b) => b.usefulnessScore - a.usefulnessScore),
    isAdmin: state.profile.isAdmin,
  };
}

const mapDispatchToProps = {
  loadFaQs,
  updateFaqUsefulnessScore,
};

export default connect(mapStateToProps, mapDispatchToProps)(FaQPage);
